module.exports = __webpack_public_path__ + "static/media/rectangular.ee4f19b0.svg";